import React, { useState, useEffect, useContext, useRef } from 'react';
import { UserContext } from "../contexts/user";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// import './style.css';

// import animationData from './courses_lottie.json'; 

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuActive, setIsMenuActive] = useState(false);
  const [hideHeader, setHideHeader] = useState(false);
  const lastScrollY = useRef(0);
  const { authenticated = false, user, handleLogout, loadingAuthState } = useContext(UserContext);

  const isHomePage = location.pathname === '/';

  useEffect(() => {
    // Handle scroll to hide/show header
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY.current && currentScrollY > 50) { // Add threshold
        setHideHeader(true);
      } else {
        setHideHeader(false);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuActive(!isMenuActive);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const menu = document.getElementById('hnHeaderMenu');
      const menuBtn = document.getElementById('hnHeaderMenuBtn');
      if (menu && menuBtn && !menu.contains(e.target) && !menuBtn.contains(e.target)) {
        setIsMenuActive(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  //  useEffect(() => {
  //   // Load Lottie Player script
  //   const script = document.createElement('script');
  //   script.src = 'https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js';
  //   script.async = true;
  //   document.head.appendChild(script);

  //   return () => {
  //     document.head.removeChild(script);
  //   };
  // }, []);

  return (
    <>
      <header className={`hn-header ${hideHeader ? 'hide-header' : ''}`}>
        <div className="hn-header-left">
          <Link
            to="/"
            className="hn-logo-link"
            title="HackerNoon Home"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <lottie-player
              src="/courses_lottie.json"
              background="transparent"
              speed="1"
              style={{ width: '192px', height: '64px' }}
              loop
              autoplay>
            </lottie-player>
          </Link>
        </div>

        <div className="hn-header-right">
          {!loadingAuthState && (
            <>
              {authenticated ? (
                <>
                  {user && (
                    <>
                      <div className='user-avatar' onClick={() => window.open(`https://hackernoon.com${user?.handle ? `/u/${user?.handle}` : "/onboarding"}`, "_blank")}>
                        <img src={user?.avatar} alt={`${user?.handle || "userl"}-avatar`} />
                      </div>
                      <span className="user-handle">Welcome @{user?.handle || "hacker"}</span>
                    </>

                  )}
                  <Link className="hn-header-link hn-progress-link"
                    to="/my-courses"
                  >
                    My Courses
                  </Link>
                </>
              ) : (
                <Link className="hn-header-link hn-login-btn" to="/login">
                  Get Started
                </Link>
              )}
            </>
          )}


          <button
            className={`hn-header-hamburger ${isMenuActive ? 'active' : ''}`}
            id="hnHeaderMenuBtn"
            aria-label="Open menu"
            onClick={toggleMenu}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>

          <nav className={`hn-header-menu ${isMenuActive ? 'active' : ''}`} id="hnHeaderMenu">
            <HashLink to={`/#introduction`}>Introduction</HashLink>
            <HashLink to={`/#faculty`}>Faculty</HashLink>
            <HashLink to={`/#features`}>Course Features</HashLink>
            <HashLink to={`/#values`}>Course Values</HashLink>
            <HashLink to={`/#testimonials`}>Testimonials</HashLink>
            <HashLink to={`/#ownership`}>Content Ownership</HashLink>
            <HashLink to={`/#pricing`}>Buy Blogging Course</HashLink>
            <HashLink to={`/#faq`}>FAQ</HashLink>
            <a href="https://hackernoon.com/">Visit HackerNoon.com</a>

            {/* <a href="/#introduction">Introduction</a>
          <a href="/#faculty">Faculty</a>
          <a href="/#features">Course Features</a>
          <a href="/#values">Course Values</a>
          <a href="/#testimonials" target='_self'>Testimonials</a>
          <a href="/#ownership">Content Ownership</a>
          <a href="/#pricing">Buy Blogging Course</a>
          <a href="/#faq">FAQ</a>
          <a href="https://hackernoon.com/">Visit HackerNoon.com</a> */}
            {(authenticated && !!user?.course?.orderId) && (
              <Link to={`/orders/${user?.course?.orderId}`} >My Receipt</Link>
            )}
            {authenticated && (<a onClick={handleLogout} href="#">Log Out</a>)}
          </nav>
        </div>
      </header>

      {isHomePage && (
        <div className={`ad-banner ${hideHeader ? 'hide-banner' : ''}`}>
          <div className="ad-banner-content">
            <a href="https://teach-on-hackernoon.paperform.co/" className="ad-banner-text">
              🎓 Share What You Know. Teach a Course on HackerNoon!
            </a>
          </div>
        </div>
      )}
    </>
  );
};


export default Header;